import React from "react";

const Checkmark = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="10.993" height="10.003" viewBox="0 0 10.993 10.003">
			<path
				id="icons8-check"
				d="M16.263,8.623a.576.576,0,0,0-.468.27l-5.419,8.291L6.865,14.151a.576.576,0,1,0-.756.864l4.015,3.475a.575.575,0,0,0,.855-.126l5.788-8.84a.576.576,0,0,0-.5-.9Z"
				transform="translate(-5.874 -8.623)"
				fill="#96de99"
			/>
		</svg>
	);
};

export default Checkmark;
